import WallCommon from "./wallCommon";
import {createPageToLoadArray} from "../../constants";

export default class FrontWall extends WallCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'front_wall';
    this.partName = 'Front Wall';
    this.dbName = 'Front Wall';
    this.translateId = "visualizer.bathroom.walls.front_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    this.hasAdditionalParts = true;
    this.additionalPartPartId = "front_wall_crop";
    if (isChild) {
      createPageToLoadArray(this);
    }
  }

  load(dbFeature) {
    if (dbFeature.groupName === 'Front Wall Crop' && (dbFeature.metaData?.RoomLayout?.includes('19')
      || dbFeature.metaData?.RoomLayout?.includes('Layout19'))) {
      dbFeature.metaData.ZSorting = 9.353429775198524;
    }
    const partNumber = dbFeature.groupName === this.dbName ? 1 : 2;
    return super.load_(dbFeature, new FrontWall(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

}
